import { AdminApi } from 'stylemix-vue-admin'

export default class PayoutsApi extends AdminApi {
  constructor(parameters) {
    super('payouts', parameters)
  }

  process(ids, user_id, config = {}) {
    return this.submit(
      'post',
      `/${this.endpoint}/process`,
      ids ? { ids, user_id } : { user_id },
      config,
    )
  }
}
